import * as React from "react";
import AccountBalanceWalletIcon from "@mui/icons-material/AccountBalanceWallet";
import { Typography, Box, Avatar, CircularProgress, Stack } from "@mui/material";
import { connect } from "react-redux";
import { getWallet } from "../../app/store/actions/authActions";
import { centered_flex_box } from "../../app/components/Styles";
import { marketingColors, marketingFonts } from "../../app/components/tickitMarketingTheme";
import { MarketingCard, MarketingButton } from "../../app/components/marketing";

export const ViewWallet = ({ getWallet, wallet, isLoading }) => {
  React.useEffect(() => {
    getWallet();
  }, []);

  if (isLoading) {
    return (
      <Box sx={{ ...centered_flex_box, py: 4 }}>
        <CircularProgress sx={{ color: marketingColors.p700 }} />
      </Box>
    );
  }

  return (
    <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", width: "100%" }}>
      <Avatar sx={{ m: 1, bgcolor: marketingColors.p700 }}>
        <AccountBalanceWalletIcon />
      </Avatar>
      <Typography
        component="h2"
        variant="h5"
        sx={{
          fontFamily: marketingFonts.display,
          fontWeight: 800,
          color: marketingColors.gray900,
          mb: 2,
        }}
      >
        Wallet
      </Typography>
      <MarketingCard sx={{ width: "100%", maxWidth: 400 }}>
        <Typography
          sx={{
            fontFamily: marketingFonts.body,
            fontSize: "0.85rem",
            fontWeight: 700,
            color: marketingColors.gray500,
            textTransform: "uppercase",
            letterSpacing: "0.06em",
            mb: 0.5,
          }}
        >
          Account balance
        </Typography>
        <Typography
          sx={{
            fontFamily: marketingFonts.display,
            fontWeight: 800,
            fontSize: "1.75rem",
            color: marketingColors.p700,
            mb: 2,
          }}
        >
          {wallet?.balance} EGP
        </Typography>
        <Stack direction="row" spacing={1} justifyContent="center" sx={{ pt: 2, borderTop: `1px solid ${marketingColors.gray200}` }}>
          <MarketingButton disabled size="small">Deposit</MarketingButton>
          <MarketingButton disabled size="small">Withdraw</MarketingButton>
        </Stack>
      </MarketingCard>
    </Box>
  );
};

const mapStateToProps = (state) => ({
  wallet: state?.auth?.wallet,
  isLoading: state?.auth?.wallet?.isLoading,
});

const mapDispatchToProps = { getWallet };

export default connect(mapStateToProps, mapDispatchToProps)(ViewWallet);
